<script setup lang="ts">
import type { DocumentNode } from '@marvr/storyblok-rich-text-types'
import Renderer from '../../services/rich-text/component'

defineProps<{
  document: DocumentNode
}>()
</script>

<template>
  <div class="flex flex-col">
    <Renderer :document="document" />
  </div>
</template>
